module.exports = __webpack_public_path__ + "img/image8.9b5701db.jpeg";